export default __webpack_public_path__ + "static/media/pickup.2181a981.svg";